const SCRIPT_SELECTOR = 'script[data-afterpay-sdk]';
const LOADER_SELECTOR = 'script[data-afterpay-loader]';
const PRODUCT_PRICE_SELECTOR = '.product-information product-price [ref="priceContainer"]';
const CART_PAGE_SELECTOR = '.cart-page__summary .cart__installments';
const CART_DRAWER_SELECTOR = 'cart-drawer-component .cart__installments';
const CART_DRAWER_OBSERVER_SELECTOR = 'cart-drawer-component cart-items-component[data-drawer]';

let loadPromise;

/**
 * Load the third-party SDK once a visible product/cart experience can use it.
 *
 * @returns {Promise<void>}
 */
function loadAfterpay() {
  if (loadPromise) return loadPromise;

  const existingScript = document.querySelector(SCRIPT_SELECTOR);
  if (existingScript instanceof HTMLScriptElement) {
    loadPromise = Promise.resolve();
    return loadPromise;
  }

  const loader = document.querySelector(LOADER_SELECTOR);
  const scriptUrl = loader instanceof HTMLScriptElement ? loader.dataset.afterpayScript : '';
  if (!scriptUrl) return Promise.resolve();

  const script = document.createElement('script');
  script.src = scriptUrl;
  script.defer = true;
  script.dataset.afterpaySdk = '';

  loadPromise = new Promise((resolve, reject) => {
    script.addEventListener('load', () => resolve(), { once: true });
    script.addEventListener('error', () => reject(new Error('Afterpay SDK failed to load.')), { once: true });
  });

  document.head.appendChild(script);
  return loadPromise;
}

function safelyLoadAfterpay() {
  loadAfterpay().catch((error) => console.warn(error));
}

function hasImmediatePlacement() {
  return (
    document.querySelector(PRODUCT_PRICE_SELECTOR) instanceof HTMLElement ||
    document.querySelector(CART_PAGE_SELECTOR) instanceof HTMLElement
  );
}

function scheduleAfterpayLoad() {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(safelyLoadAfterpay, { timeout: 1500 });
  } else {
    window.setTimeout(safelyLoadAfterpay, 0);
  }
}

if (hasImmediatePlacement()) scheduleAfterpayLoad();

document.addEventListener(
  'dialog:open',
  (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('cart-drawer-component')) return;
    safelyLoadAfterpay();
  },
  { capture: true }
);

document.addEventListener('cart:update', () => {
  requestAnimationFrame(() => {
    const openDrawer = document.querySelector('cart-drawer-component dialog[open]');
    if (hasImmediatePlacement() || openDrawer) safelyLoadAfterpay();
  });
});
